import { render, staticRenderFns } from "./VisitsTable.vue?vue&type=template&id=45e3685a&scoped=true&"
import script from "./VisitsTable.vue?vue&type=script&lang=js&"
export * from "./VisitsTable.vue?vue&type=script&lang=js&"
import style0 from "./VisitsTable.vue?vue&type=style&index=0&id=45e3685a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e3685a",
  null
  
)

export default component.exports